// Copyright (c) 2025 DTCC and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { UseMutationResult, useMutation } from '@tanstack/react-query';
import { InstrumentSecurityControlService } from '@daml.js/dtc-registry-app/lib/Dtc/Registry/App/V3/Service/InstrumentSecurityControl';
import { ContractId } from '@daml/types';
import { useLedgerApiClient } from '../../../../contexts/LedgerApiContext';

const useTerminateInstrumentSecurityControlService: () => UseMutationResult<
  void,
  string,
  {
    instrumentSecurityControlServiceCid: ContractId<InstrumentSecurityControlService>;
  }
> = () => {
  const ledgerApi = useLedgerApiClient();

  return useMutation({
    mutationKey: ['terminateRegistryInstrumentSecurityControlService', ledgerApi],
    mutationFn: async ({ instrumentSecurityControlServiceCid }) =>
      ledgerApi.terminateRegistryInstrumentSecurityControlService(
        instrumentSecurityControlServiceCid,
      ),
    retry: false,
  });
};

export default useTerminateInstrumentSecurityControlService;
